import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import './PrintContainer.css';

interface PrintContainerProps {
  printButton: (handlePrint: () => void) => JSX.Element;
  children: React.ReactNode;
}

function PrintContainer({ printButton, children }: PrintContainerProps) {
  const printViewRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: printViewRef });

  return (
    <>
      {printButton(() => reactToPrintFn())}
      <div className="print-view-container">
        <div ref={printViewRef}>
          { children }
        </div>
      </div>
    </>
  );
}

export default PrintContainer;